import { useSwrNoAuth } from "../../swr/useSwrNoAuth";

export const useFetchCustomerLastVisitDate = (restaurantId: string, lineId: string) => {
  const { data: lastVisitDate, error, isLoading: isLoadingLastVisitDate } = useSwrNoAuth<string>(`external_api/restaurants/${restaurantId}/line-accounts/${lineId}/last-visit/`)
  return { lastVisitDate, isLoadingLastVisitDate, error };
};